class HomeImage {
  constructor() {
    this.imagesData = [];
    this.servedImageIDS = [];
    this.localStorageName = 'lmc_home_images';
    this.imageToShow = null;
    this.potentialImages = [];
  }

  init() {
    if (!document.querySelector('.js-home-images')) {
      return;
    }
    // if (localStorage.getItem(this.localStorageName)) {
    //   console.log(
    //     'firing home images',
    //     localStorage.getItem(this.localStorageName)
    //   );
    // } else {
    //   console.log('not set', localStorage.getItem(this.localStorageName));
    // }

    this.getImageData();
    this.checkStorage();
    this.findImageToShow();
    this.showImage();
    this.setStorage();
  }

  getImageData() {
    // Get currently available images from DOM
    const imagesData = [];
    Array.from(document.querySelectorAll('.js-home-images')).map(image => {
      // Object to push to array to store all info
      const imageID = image.getAttribute('data-id');
      const imageAlt = image.getAttribute('data-alt');
      const imageSrc = image.getAttribute('data-src');
      const imageEl = image;

      const ImageDataToPush = {
        imageID,
        imageAlt,
        imageSrc,
        imageEl
      };

      return imagesData.push(ImageDataToPush);
    });

    this.imagesData = imagesData;
  }

  // Check what images the user has seen previously
  checkStorage() {
    if (!localStorage.getItem(this.localStorageName)) return;

    const stored = localStorage.getItem(this.localStorageName).split(',');

    if (stored) {
      const numericArray = [...stored].filter(
        id => !Number.isNaN(parseFloat(id))
      );
      this.servedImageIDS = numericArray;
    }
  }

  findImageToShow() {
    const { imagesData } = this;

    const { servedImageIDS } = this;
    this.servedImageIDS = servedImageIDS;

    // If nothing set in storage then serve first available image
    if (!servedImageIDS || servedImageIDS.length < 1) {
      this.imageToShow = imagesData[0];
    }

    // Check if any can be shown
    const potentialImages = imagesData.filter(
      image => !servedImageIDS.includes(image.imageID)
    );
    this.potentialImages = potentialImages;

    if (potentialImages.length > 0) {
      this.imageToShow = potentialImages[0];
    } else {
      // If no potential images then show first possible and reset
      this.imageToShow = this.imagesData[0];
    }
  }

  showImage() {
    const { imageSrc, imageEl } = this.imageToShow;
    imageEl.removeAttribute('hidden');
    imageEl.addEventListener('load', this.imageLoaded);
    imageEl.addEventListener('error', this.imageLoadError);
    imageEl.src = imageSrc;
  }

  imageLoaded() {
    const hero = document.querySelector('.js-hero-rotating');
    hero.style.minHeight = 'auto';
  }

  imageLoadError() {
    const hero = document.querySelector('.js-hero-rotating');
    hero.style.minHeight = 'auto';
  }

  setStorage() {
    // If no potential images then reset stored
    if (this.potentialImages.length < 1) {
      localStorage.setItem(this.localStorageName, [this.imageToShow.imageID]);
      return;
    }

    const { servedImageIDS } = this;

    let updatedServedIDS = [...servedImageIDS];
    updatedServedIDS.push(this.imageToShow.imageID);
    updatedServedIDS = updatedServedIDS.join();

    localStorage.setItem(this.localStorageName, updatedServedIDS);
  }
}

export default HomeImage;
